import React from 'react';
import classnames from 'classnames';
import { PopupDialog } from 'swag-client-common/components/info/popup-dialog/popup-dialog';
import { Button, ButtonType } from 'swag-client-common/components/ui/button';
import classes from './confirm-goodie-unused-budget-popup.scss';
const titleClasses = {
  root: classes.titleContainer
};
const footerClasses = {
  spacing: classes.footer
};
const popupClasses = {
  paper: classnames(classes.popupContainer, classes.popup)
};
export const ConfirmGoodieUnusedBudgetPopupComponent = ({
  open,
  budget,
  onClose,
  onConfirm,
  buttonColor
}) => {
  return /*#__PURE__*/React.createElement(PopupDialog, {
    open: open,
    onClose: onClose,
    title: "Hey! You didn't use your entire budget!",
    dataPopup: "SubmitGoodieUnusedBudgetPopup",
    footerClasses: footerClasses,
    classes: popupClasses,
    titleClasses: titleClasses,
    closeClass: classes.closeButton,
    titleHeader: classes.title,
    contentClass: classes.content,
    closeStyles: {
      backgroundColor: buttonColor
    },
    footer: /*#__PURE__*/React.createElement(Button, {
      dataButton: "Confirm",
      className: classes.button,
      style: {
        backgroundColor: buttonColor,
        borderColor: buttonColor
      },
      type: ButtonType.primary,
      onClick: onConfirm
    }, "Continue"),
    content: /*#__PURE__*/React.createElement("div", {
      className: classes.description
    }, "You still have some budget left, so we will try to find a special surprise to add based on the amount you have remaining.")
  });
};